import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  dropdownAndProduct: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    height: theme.spacing(5.5),
  },
  dropDownWidth: {
    width: theme.spacing(22.125),
  },
  filtersWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 5),
    height: theme.spacing(5.5),
  },
  labelContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  labelContentTitle: {
    alignSelf: 'center',
    color: theme.palette.shadows.dark,
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  labelSubTitle: {
    color: theme.palette.shadows.light,
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  dateRangePickerWrrapper: {
    width: theme.spacing(27.875),
    '& .MuiOutlinedInput-adornedEnd': {
      background: 'none',
    },
  },
  selectWrapper: {
    backgroundColor: theme.palette.textBackground.light,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(3, 4, 2, 4),
  },
  selectWidth: {
    width: theme.spacing(36.375),
  },
}))
